import { IOS_CORDOVA_USER_AGENT, ANDROID_USER_AGENT, HOST_TYPE } from './consts';
import includes from 'lodash.includes';
function isIframe() {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
}
// We use the user agent to detect if the app is loaded inside iOS / Android Cordova WebView.
// The hosting app should append the same user agent constant to the user agent when initializing the WebView.
function isUserAgentContains(str) {
    return includes(navigator.userAgent, str);
}
function isIOSCordovaApp() {
    return isUserAgentContains(IOS_CORDOVA_USER_AGENT);
}
function isAndroidApp() {
    return isUserAgentContains(ANDROID_USER_AGENT);
}
export function resolveHostType() {
    if (isIOSCordovaApp()) {
        return HOST_TYPE.IOS_CORDOVA;
    }
    else if (isAndroidApp()) {
        return HOST_TYPE.ANDROID;
    }
    else if (isIframe()) {
        return HOST_TYPE.IFRAME;
    }
    return HOST_TYPE.WEB_COMPONENT;
}
// We use this method instead of the URL.searchParams API to support all browsers (mainly IE11 and Edge).
export function getQueryString(...args) {
    let key = false;
    const res = '';
    let itm = null;
    // get the query string without the ?
    const qs = location.search.substring(1);
    // check for the key as an argument
    if (args.length > 0 && args[0].length > 1) {
        key = args[0];
    }
    // make a regex pattern to grab key/value
    const pattern = /([^&=]+)=([^&]*)/g;
    // loop the items in the query string, either
    // find a match to the argument, or build an object
    // with key/value pairs
    // tslint:disable-next-line:no-conditional-assignment
    while ((itm = pattern.exec(qs))) {
        // eslint-disable-line
        if (key !== false && decodeURIComponent(itm[1]) === key) {
            return decodeURIComponent(itm[2]);
        }
        else if (key === false) {
            res[decodeURIComponent(itm[1])] = decodeURIComponent(itm[2]);
        }
    }
    return key === false ? res : null;
}
//# sourceMappingURL=data:application/json;base64,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